import type { AgentStatus } from '../_contract/agentChat';

export const MAX_AGENT_INSTRUCTION_LENGTH = 4000;

export const AGENT_CHAT_STATUS: Record<AgentStatus, string> = {
    thinking: 'Sending to the engine...',
    queued: 'Waiting for the worker...',
    working: 'Agent is editing and running checks...',
    idle: 'Ready',
    error: 'Last request failed',
    input: 'Waiting for your input or approval',
};
